import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLang } from '../../i18n/LanguageContext';

export default function TopBar({ activeOrderCount = 0, onMenuToggle }) {
  const { lang, t, toggle } = useLang();
  const [time, setTime] = useState(new Date());
  const [user, setUser] = useState(null);

  useEffect(() => {
    try {
      const stored = localStorage.getItem('ownerUser');
      if (stored) setUser(JSON.parse(stored));
    } catch {}
  }, []);

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (d) =>
    d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

  const formatDate = (d) =>
    d.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

  const username = user?.email ? user.email.split('@')[0] : 'Owner';

  return (
    <motion.header
      className="topbar"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="topbar-left">
        <button className="topbar-hamburger" onClick={onMenuToggle} aria-label="Toggle menu">
          <i className="bi bi-list"></i>
        </button>
        <div className="topbar-left-text">
          <h2 className="topbar-greeting">{t('topbar.welcome')} <span>{username}</span></h2>
          <p className="topbar-date">{formatDate(time)}</p>
        </div>
      </div>
      <div className="topbar-right">
        {activeOrderCount > 0 && (
          <motion.div
            className="topbar-alert"
            animate={{ scale: [1, 1.05, 1] }}
            transition={{ repeat: Infinity, duration: 2 }}
          >
            <i className="bi bi-bell-fill me-1"></i>
            <span>{activeOrderCount} {activeOrderCount !== 1 ? t('topbar.activeOrders') : t('topbar.activeOrder')}</span>
          </motion.div>
        )}
        {/* Language switch (EN | 中) */}
        <button
          className={`lang-switch ${lang === 'zh' ? 'zh' : 'en'}`}
          onClick={toggle}
          title={lang === 'en' ? 'Switch to Chinese' : '切换到英文'}
          aria-label="Toggle language"
        >
          <span className="lang-switch-track">
            <span className="lang-switch-opt">EN</span>
            <span className="lang-switch-opt">中</span>
            <span className="lang-switch-thumb"></span>
          </span>
        </button>
        <div className="topbar-clock">
          <i className="bi bi-clock me-2"></i>
          <span>{formatTime(time)}</span>
        </div>
      </div>
    </motion.header>
  );
}
